import React from 'react';
import styled from 'styled-components';
import { StyledSvg } from './SideNavIndividual';
import css from '../../../css/css-variables';
import { GroupTitle } from './SideNavOrg';
import UserIcon from '../../../img/sprite/indv-user-icon.svg';
import { Link } from 'react-router-dom';
import { truncateString } from '../utils/formUtils';

const StyledButton = styled.button`
  font-size: 14px;
  color: ${css.colors.Progress};
  text-decoration: none;
  text-align: left;

  &:hover {
    ${({noHover}) => noHover ? '' : 'text-decoration: underline'};
  }
`;

export const SignOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: fit-content;
  margin-top: 10px;
`;

export const SignOutText = styled.p`
  font-size: 12px;
  color: ${css.colors.Progress};
  pointer-events: auto;

  :hover {
    text-decoration: underline;
  }
`;

export const AccountContainer = styled(Link)`
  display: flex;
  height: 46px;
  padding: 0px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid ${({active}) => active ? css.colors.LifewayGold : css.colors.BorderGray};
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
  color: ${css.colors.DarkGray};
  
  :hover {
    border: 1px solid ${css.colors.LifewayGold};
    text-decoration: underline;
  }
`;

export const SelectViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

function SideNavSelect ({
  setView,
  loading,
  showMoreOrgs,
  orgButtonLinks,
  handleSelectOrg,
  setSelectedOrg,
  setViewAccountsModal,
  view,
  pathname
}) {

  return (
    <>
      <GroupTitle>Switch Account</GroupTitle>
      <SelectViewContainer>
        {!loading && view === 'ORG' &&
          <AccountContainer
            aria-label="My Account"
            type='button'
            role="button"
            onClick={() => {
              setView('INDIVIDUAL');
              setSelectedOrg('');
            }}
            to="/account-home"
            data-tracking-component="button"
            data-tracking-id="my-account"
            data-qa-hook="side-nav-individual-link"
          >
            <StyledSvg
              width="32px"
              height="32px"
              flexShrink="0"
              marginRight="0"
            >
              <use href={`#${UserIcon.id}`} />
            </StyledSvg>
            My Account
          </AccountContainer>
        }
        {!loading && orgButtonLinks && orgButtonLinks?.map((org, index) => (
            <AccountContainer
              type="button"
              role="button"
              aria-label="Select Org"
              onClick={() => handleSelectOrg(org)}
              key={index}
              to={`/organization/${org?.organizationId}/account-home`}
              active={pathname.includes(org?.organizationId)}
              data-qa-hook="side-nav-org-link"
              data-tracking-component="button"
              data-tracking-id="organization"
            >
              <StyledSvg
                width="32px"
                height="32px"
                flexShrink="0"
                marginRight="0"
              >
                <use href={`#${org?.orgIcon?.id}`} />
              </StyledSvg>
              {truncateString(org?.organizationName, 50)}
            </AccountContainer>
        ))}
        {showMoreOrgs && (
          <StyledButton
            type="button"
            onClick={() => setViewAccountsModal()}
            noHover={true}
          >
            View More Accounts
          </StyledButton>
        )}
      </SelectViewContainer>
    </>
  );
}

export default SideNavSelect;